import React from 'react'
import styles from './LbSetupGuide.module.css'
import { motion } from 'framer-motion'
import { FaUserShield, FaPaste, FaCheckCircle } from 'react-icons/fa'

const steps = [
    {
        icon: <FaUserShield />,
        title: 'Step 1: Generate Token',
        description: 'Login to CRM and generate a unique encrypted LeadBridge™ token for your website or form.'
    },
    {
        icon: <FaPaste />,
        title: 'Step 2: Add Script or PHP Snippet',
        description: 'Paste the script (for HTML) or PHP snippet into your website’s form file right before the closing </form> tag.'
    },
    {
        icon: <FaCheckCircle />,
        title: 'Step 3: Test Submission',
        description: 'Submit a test form and instantly view the captured lead inside your CRM dashboard under “LeadBridge Inquiries”.'
    }
]

const LbSetupGuide = () => {
    return (
        <section className={styles.setupGuide}>
            <div className={styles.container}>
                <motion.h2
                    className={styles.heading}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    viewport={{ once: true }}
                >
                    Setup in Just 3 Easy Steps
                </motion.h2>

                <div className={styles.steps}>
                    {steps.map((step, index) => (
                        <motion.div
                            className={styles.step}
                            key={index}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.2, duration: 0.5 }}
                            viewport={{ once: true }}
                        >
                            <div className={styles.icon}>{step.icon}</div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default LbSetupGuide
